var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	53858: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(4674))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	39817: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(74794))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	93888: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(53987))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	59890: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(96076))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "1.16.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",

	},
	10742: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(10711))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "jwt-decode",

	},
	86216: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(36905))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "1.1.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@toorak/op-web-core-sdk",

	},
	91253: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(24598))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "1.25.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@toorak/op-web-tw-component",

	},
	99945: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(11544))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^0.539.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "lucide-react",

	},
	5839: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(97748))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.39.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-query",

	},
	51253: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(32254))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.4.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	14234: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(42913))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.0.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "setimmediate",

	},
	95602: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(99807))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "11.10.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",

	},
	91136: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(94370))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^15.8.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "prop-types",

	},
	89970: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(89000))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "11.10.4",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/styled",

	},
	72723: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(16649))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^5.18.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mui/material",

	},
	64627: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(55388))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^5.18.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mui/styles",

	},
	14275: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(18496))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^6.7.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@casl/ability",

	},
	44968: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(73203))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^5.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@casl/react",

	},
	16346: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(226)]).then(() => (() => (__webpack_require__(8351))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "3.1.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@toorak/op-eventbus-sdk",

	},
	14911: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(51127))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^21.9.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	},
	12794: {
		fallback: () => (__webpack_require__.e(96).then(() => (() => (__webpack_require__(35832))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^11.18.6",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	94576: {
		fallback: () => (Promise.all([__webpack_require__.e(96), __webpack_require__.e(136), __webpack_require__.e(602), __webpack_require__.e(970), __webpack_require__.e(657)]).then(() => (() => (__webpack_require__(95239))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "1.7.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@toorak/document-extraction-component-library",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"119": [
		14275,
		44968,
		16346,
		14911,
		12794
	],
	"136": [
		91136
	],
	"468": [
		94576
	],
	"602": [
		95602
	],
	"657": [
		72723,
		64627
	],
	"701": [
		86216,
		91253,
		99945,
		5839,
		51253,
		14234
	],
	"742": [
		10742
	],
	"817": [
		39817
	],
	"858": [
		53858
	],
	"888": [
		93888
	],
	"890": [
		59890
	],
	"970": [
		89970
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}